<template>
	<div :class="['intro']">
		<bread-crumbs theme="white" v-if="activeRootCategory"></bread-crumbs>

		<sign-in v-if="!user"></sign-in>
			<transition-group
        		tag="div" appear
                     class="categories-links"
                    @before-enter="beforeEnter"
                    @enter="enter"
                    @leave="leave">
              
            
			<router-link
				v-for="(category,i) in currentCategories" :key="category.name"
				:to="getLink(category)"
				 :data-index="i"
				>
				<!-- @click.native.prevent.stop="catClickHandler($event, category)" -->
				<img :src="parseImgSrc(category)" alt="">
				<!-- <kinesis-element 
                  tag="img"
                  :src="parseImgSrc(category)"
                  :strength="10"
									axis="x"
									cycle="2"
									 />
				<kinesis-element 
                  tag="span"
                  v-text="category.name"
                  :strength="10"
									axis="x"
									cycle="2"

									 /> -->
				<span
				
				 v-text="category.name"></span>
			</router-link>
			</transition-group>
										<!-- </kinesis-container> -->
		<!-- <video class="bg-vid" autoplay loop muted controls>
			<source src="/video/Robot-bright.mp4" type="video/mp4">
		</video> -->
		<bg-slider :imglist="images"></bg-slider>
	</div>
</template>
<script>
import BreadCrumbs from '@/ui/components/BreadCrumbs.vue';

import { mapState, mapGetters } from 'vuex';
import searchBox from '../../components/searchBox.vue';
import bgSlider from '../../components/bgSlider.vue';
import SignIn from '../../components/SignIn.vue';
export default {
	props: ["categories", "activeCategory", "activeRootCategory"],
	data() {
		return {
			images:['/img/backgrounds/background-2.gif', 
			'/img/backgrounds/background-1.jpg'],
		}
	},
	components: {
		searchBox,
		bgSlider,
		SignIn,
		BreadCrumbs

	},
	methods: {
		beforeEnter: function (el) {
            el.style.opacity = 0;
            el.style.transform = 'translateY(20%)';
		},
		enter: function (el, done) {
            var vm = this;
            var delay = el.dataset.index * 45;
			setTimeout(function () {
                el.animate(
                {
                    opacity: [0,1],
                    transform: ['translateY(20%)', 'translateY(0)'],
                    easing: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)'
                },
				{ duration: vm.isIE ? 100 : 600, fill: 'forwards'}).onfinish = function() {
                    done()
                };
			}, delay)
		},
		leave: function (el, done) {
            el.style.opacity = 0;
            el.style.transform = 'translateY(120%)';
			done();
		},
		parseImgSrc(cat) {
			if (cat.src) {
				return cat.src
			}
			let catname = cat.name.trim();
			let filename = catname.replace(/[\s]*&[\s]*/g, '_and_').replace(/ /g, '_').replace(/\+/g, '_plus');
			return `/img/categories/${filename}.png`
		},
		getLink(cat) {
			if (cat.children.length) {
				if (cat.parent>-1) {
					console.log("get link >> ", cat);
					return { name: 'sub-menu2', params: { category: this.activeCategory.name, subcat: cat.name } }
				}
				return { name: 'sub-menu', params: { category: cat.name } }
			}
			else if (this.isSubmenu) {
				if (this.$route.name==='sub-menu2') {
					return { name: 'results-grandchild', params: { 
						category: this.activeRootCategory.name,
						subcat: this.activeCategory.name, grandchildFilter: cat.name  } }
				}
					return { name: 'results-child', params: { category: this.activeCategory.name, subcat: cat.name  } }
			}
			// else if (this.isSubmenu) {
				return { name: 'results-root', params: { category: cat.name } }
			// }
		}
	},
	computed: {
		...mapState([
			'user',
			'loaded'
			// 'categories'
		]),
		...mapGetters([
            'isDevice',
						'isIE',
						'isSubmenu'
        ]),
		currentCategories() 
		{
			try
			{
				let temp =  this.activeCategory ? this.activeCategory.children : this.categories;
				let clonedArray = temp.map(x => x);//clone the array 

				//Remove the "New" catgory 
				if(clonedArray[0].name == "New"){
					clonedArray = clonedArray.splice(1);
				}
				return clonedArray;
			}catch{}
		}
	}
}
</script>
<style lang="stylus">
@import '~rupture'
@import '~settings'
.intro
	// lost-align center
	position relative
	width 100%
	height 100vh
	//background-color #002d56
	z-index 1
	+below(815px)
		height auto
		padding-bottom 50px
.bg-vid
	width 100%
	height 100%
	z-index 2
	object-fit cover
.categories-links	
	margin-bottom 150px
	// self-center()
	display flex
	text-align center
	justify-content center
	align-items flex-start
	flex-wrap wrap
	width 100%
	padding 0 5%
	padding-top 40px
	//height 100%
	height auto
	align-content center
	// max-height 80%
	+below(815px)
		padding 0px
		height auto
	& > a
		margin 1.5% 1%
		text-decoration none
		text-align center
		color #2f2f2f !important
		//height 25vh
		height auto
		// width 10vw
		//flex 0 0 30%
		flex 0 0 20%
		+below(815px)
			flex 0 0 40%
		+below(900px)
			height 21vmax
		&:at-least(7)
			flex 0 0 20%
			+below(815px)
				flex 0 0 40%
		img
			display block
			margin auto
			max-width 70%
			max-height 83%
		+below(1100px)
			margin 2% 1%
			img
				max-width 90%

		span
			font-size responsive 12px 16px
			letter-spacing 0px
			display block
			text-align center
			padding-top 8px
			font-weight 100 !important
		// @media all and (min-width:1200px) and (max-height:750px)
		// 	margin 1.3% 1%
		// 	flex 1
		// 	height 28vh
		// 	width 10vw
		// 	flex 0 0 20%
		// 	span
		// 		font-size 18px
</style>
